function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ebebeb;}.cls-2{fill:#cccccb;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Lock");

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_351",
  "data-name": "Ellipse 351",
  className: "cls-1",
  cx: 254,
  cy: 254,
  r: 254
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Group_16003",
  "data-name": "Group 16003"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_14769",
  "data-name": "Path 14769",
  className: "cls-2",
  d: "M259.66,331.67c-19.76,0-39.53.05-59.29,0-12.3,0-17.79-5.59-17.82-18.08q-.11-40.12,0-80.25c0-11.92,5.67-17.68,17.58-17.7q59.63-.12,119.25,0c11.77,0,17.24,5.47,17.26,17.1q.11,40.46.05,80.92c0,12.58-5.33,18-17.72,18Q289.31,331.71,259.66,331.67Zm-18.53-69.81c.17,4.45,1.61,7.52,3.92,9.55,5.73,5,5.08,11.19,5,17.53,0,9.93,3.39,14.87,10.14,14.78,6.3-.08,8.93-4.09,8.81-14.22-.08-6.86-.15-13.06,5.45-18.77,5.22-5.33,4-14.24-.77-20.28-5-6.27-12.23-8.49-19.53-6-7.6,2.63-12.42,9.31-13.08,17.37Z",
  transform: "translate(-5.5 -2)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_14770",
  "data-name": "Path 14770",
  className: "cls-2",
  d: "M318.1,179c0,5.8-.05,11.6,0,17.39.05,3.89-1.68,5.67-5.63,5.64-21.43-.17-18.15,2.5-18.37-17-.08-6.69.06-13.38,0-20.06-.17-11.61-8.53-22.86-19.93-24.19a103.82,103.82,0,0,0-29,.72c-12.4,2.11-20.39,13.42-20.42,26.08,0,8.92-.18,17.84.08,26.75.16,5.34-1.6,7.77-7.23,7.67-19.55-.36-16.58,2.35-16.77-16.5-.09-8.91-.72-18,.62-26.7,3.69-24.14,22.2-40.42,49-43.06,13.9-1.37,27.95-1.45,41,5.44,17.55,9.3,25.75,24.35,26.78,43.78.25,4.67,0,9.36,0,14Z",
  transform: "translate(-5.5 -2)"
}));

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 508 508",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock.b82ce910.svg";
export { ForwardRef as ReactComponent };